import styles from './Copyright.module.scss'

const Copyright = () => (
	<div className={styles.copyright}>
		© {new Date().getFullYear()} Schools Mobile. All rights reserved.
	</div>
)

export default Copyright
